export const classes = {
  card: 'flex overflow-hidden rounded-[18px] border border-[rgba(70,60,50,0.1)] bg-white/[0.82] shadow-aurora-card px-6 py-5',
};
